import { render, staticRenderFns } from "./flowFrom.vue?vue&type=template&id=1efcca59&scoped=true&"
import script from "./flowFrom.vue?vue&type=script&lang=js&"
export * from "./flowFrom.vue?vue&type=script&lang=js&"
import style0 from "./flowFrom.vue?vue&type=style&index=0&id=1efcca59&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efcca59",
  null
  
)

export default component.exports